module.exports = __webpack_public_path__ + "static/media/tecnoshaft.4064e297.png";